import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';

// `projectId` is the project whose expense tracking asks: besides the
// business's admins, the API serves those with expense tracking in one of its
// projects.
export const getActiveAssignmentsForBusiness = async (
  businessId,
  lastEvaluatedKey,
  projectId
) => {
  const apiPath = `assignment/business/${businessId}/active-assignments`;

  const body = {
    lastEvaluatedKey: lastEvaluatedKey,
    limit: 1000,
    projectId,
  };

  const request = {
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    //url: `http://localhost:3001/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    data: body,
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    region: Config.AWS_REGION,
    service: 'execute-api',
  };
  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);

  return response.data;
};
